import { apiService } from '../api';
import { Recipe, CreateRecipeRequest } from '../../types/inventory';

const BASE = '/inventory/recipes';

export const recipeService = {
  async getRecipes(org: string, restaurantId?: string): Promise<Recipe[]> {
    const response = await apiService.get<Recipe[]>(BASE, {
      org,
      ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },

  async getRecipeByItem(menuItemId: string): Promise<Recipe | null> {
    const response = await apiService.get<Recipe | null>(`${BASE}/by-item/${menuItemId}`);
    return response.data;
  },

  async createRecipe(data: CreateRecipeRequest): Promise<Recipe> {
    const response = await apiService.post<Recipe>(BASE, data);
    return response.data;
  },

  async updateRecipe(id: string, data: Partial<CreateRecipeRequest>): Promise<Recipe> {
    const response = await apiService.put<Recipe>(`${BASE}/${id}`, data);
    return response.data;
  },

  async deleteRecipe(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}`);
  },
};
